import React from 'react';

const LoadingCircle = () => {
  return (
    <div className="w-12 h-12 border-4 border-blue-500 border-opacity-75 rounded-full animate-spin"></div>
  );
};

export default LoadingCircle;
